module.exports = __webpack_public_path__ + "static/Nihal_Navada-9414f5621c38580fd03bd5a64c971195.jpeg";